
import { required } from 'vuelidate/lib/validators'

export default {
  unit: {
    tower_id: {
      required
    },
    unit_id: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/unit/form/resources/validations.js